var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(-21 -191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 44,
    height: 44,
    transform: "translate(21 191)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image_FILL0_wght400_GRAD0_opsz48",
    d: "M7.833,28A1.88,1.88,0,0,1,6,26.167V7.833A1.88,1.88,0,0,1,7.833,6H26.167A1.88,1.88,0,0,1,28,7.833V26.167A1.88,1.88,0,0,1,26.167,28Zm0-1.833H26.167V7.833H7.833ZM9.544,23.2H24.486l-4.492-5.989-4.033,5.225-2.842-3.881ZM7.833,26.167v0Z",
    transform: "translate(26 196)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImage);
export default __webpack_public_path__ + "static/media/SearchImage.5bfeed4fcfbc965c85c59d7d7f5020ab.svg";
export { ForwardRef as ReactComponent };